<div class="kiene-content-page">
    <div *ngIf="isLoading" class="kiene-loading-spinner">
        <mat-progress-spinner *ngIf="isLoading"></mat-progress-spinner>
    </div>
    <div class="kiene-table-header">
        <div>
            <h2 style="display: inline-block; margin-left: 20px"
                >{{ laborartikelOnly ? 'Labor-Bestellungswarenkorb' : 'Warenkorb' }}
                <span *ngIf="warenkorbPositions.length > 0">( {{ warenkorbPositions.length }} Artikel )</span></h2
            >
        </div>
    </div>
    <div>
        <div style="width: 95%">
            <mat-card style="width: 100%; margin-bottom: 20px; min-height: 120px">
                <h4>Position hinzufügen</h4>
                <div style="width: 100%" class="one-row">
                    <form (ngSubmit)="addPosition()" style="width: 100%">
                        <div class="one-row">
                            <div style="min-width: 500px; margin-right: 12px">
                                <kiene-article-scan-autocomplete
                                    #articleAutocomplete
                                    [placeholder]="laborartikelOnly ? 'Diagnostikartikel auswählen' : 'Artikel auswählen'"
                                    [labor]="laborartikelOnly"
                                    [nurDiagnostikArtikel]="laborartikelOnly"
                                    [excludeLabor]="!laborartikelOnly"
                                    (selectedMaterial)="materialSelected($event)"
                                    (cleared)="materialCleared()"
                                ></kiene-article-scan-autocomplete>
                            </div>

                            <mat-form-field style="min-width: 180px; margin-right: 2%">
                                <input
                                    type="number"
                                    #amountInput
                                    matInput
                                    [formControl]="positionAmountCtrl"
                                    [placeholder]="laborartikelOnly ? 'Anzahl ' + packNameMaterial() : 'Menge'"
                                />
                                <span matSuffix>{{ laborartikelOnly ? packNameMaterial(positionAmountCtrl.value) : 'Stk.' }}</span>
                                <mat-hint *ngIf="laborartikelOnly && gebindeHinweis">{{ gebindeHinweis }}</mat-hint>
                                <mat-error *ngIf="positionAmountCtrl.invalid">Menge muss > 0 sein!</mat-error>
                            </mat-form-field>

                            <mat-form-field style="min-width: 500px; margin-right: 12px">
                                <mat-label>Kommentar</mat-label>
                                <input matInput type="text" [formControl]="kommentarCtrl" />
                            </mat-form-field>

                            <button
                                [disabled]="!positionAmountCtrl.valid || !materialCtrl.valid"
                                mat-flat-button
                                color="accent"
                                >Hinzuf&uuml;gen</button
                            >
                            <button
                                *ngIf="laborartikelOnly && selectedMaterial?.artikel_id"
                                mat-stroked-button
                                type="button"
                                class="vorschau-button"
                                (click)="openBestellvorschauAdd()"
                            >
                                <mat-icon>picture_as_pdf</mat-icon>
                                Vorschau
                            </button>

                            <span class="spacer"></span>
                        </div>
                        <div *ngIf="mindestbestellTextAdd()" class="mindest-info">{{ mindestbestellTextAdd() }}</div>
                        <div *ngIf="packInfoAdd()" class="mindest-info">{{ packInfoAdd() }}</div>
                        <div *ngIf="packFehlerAdd()" class="mindest-hint">{{ packFehlerAdd() }}</div>
                        <div *ngIf="mindestHinweisAdd()" class="mindest-hint">{{ mindestHinweisAdd() }}</div>
                        <div *ngIf="guenstigerText()" class="wirkstoff-hinweis">
                            <span>{{ guenstigerText() }}</span>
                            <button mat-stroked-button type="button" (click)="uebernehmenGuenstiger()">
                                Diesen nehmen
                            </button>
                        </div>
                    </form>
                </div>
            </mat-card>

            <div *ngIf="warenkorbPositions.length == 0 && isLoading == false">
                Zur Zeit befinden sich keine Artikel im Warenkorb.
            </div>

            <table *ngIf="laborartikelOnly && warenkorbPositions.length > 0" class="labor-korb">
                <thead>
                    <tr>
                        <th>Artikel</th>
                        <th>Lieferant</th>
                        <th>Menge</th>
                        <th>Kommentar</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let w of warenkorbPositions">
                        <td>
                            <div class="labor-korb__artikel">{{ artikelTitel(w) }}</div>
                            <div *ngIf="packFehlerPosition(w)" class="mindest-hint">{{ packFehlerPosition(w) }}</div>
                            <div *ngIf="mindestHinweisPosition(w)" class="mindest-hint">
                                {{ mindestHinweisPosition(w) }}
                            </div>
                        </td>
                        <td class="labor-korb__lieferant">
                            <kiene-supplier-material-selector
                                [kompakt]="true"
                                [materialId]="w.artikel_id"
                                [supplierId]="w.lieferant_id"
                                (change)="updateLieferant(w, $event)"
                            ></kiene-supplier-material-selector>
                        </td>
                        <td class="labor-korb__menge">
                            <input
                                class="labor-korb__zahl"
                                type="number"
                                min="1"
                                [formControl]="formCtrl[w.warenkorb_id]"
                            />
                            <span class="labor-korb__einheit">{{ packNamePosition(w) }}</span>
                        </td>
                        <td>
                            <input
                                class="labor-korb__text"
                                type="text"
                                placeholder="Kommentar"
                                [formControl]="positionKommentarCtrl[w.warenkorb_id]"
                            />
                        </td>
                        <td class="labor-korb__aktion">
                            <button
                                *ngIf="inputDirtyArray[w.warenkorb_id]"
                                mat-button
                                class="labor-korb__save"
                                color="primary"
                                type="button"
                                (click)="updateWarenkorbPosition(w)"
                            >
                                Speichern
                            </button>
                            <button
                                mat-icon-button
                                type="button"
                                title="Position entfernen"
                                (click)="removeWarenkorbPosition(w)"
                            >
                                <mat-icon>close</mat-icon>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <ng-container *ngIf="!laborartikelOnly">
            <mat-card *ngFor="let w of warenkorbPositions" style="width: 100%; margin-bottom: 20px; min-height: 120px">
                <div class="kiene-table-header">
                    <div style="display: inline-block">
                        <h3 style="width: 100%">{{ artikelTitel(w) }}</h3>
                        <div *ngIf="mindestbestellTextPosition(w)" class="mindest-info">
                            {{ mindestbestellTextPosition(w) }}
                        </div>
                        <div *ngIf="packInfoPosition(w)" class="mindest-info">{{ packInfoPosition(w) }}</div>
                        <div *ngIf="packFehlerPosition(w)" class="mindest-hint">{{ packFehlerPosition(w) }}</div>
                        <div *ngIf="mindestHinweisPosition(w)" class="mindest-hint">{{ mindestHinweisPosition(w) }}</div>
                        <div style="font-size: 14px; color: #999">
                            <kiene-supplier-material-selector
                                [materialId]="w.artikel_id"
                                [supplierId]="w.lieferant_id"
                                (change)="updateLieferant(w, $event)"
                            ></kiene-supplier-material-selector
                            ><br />
                            <mat-form-field style="width: 500px; color: black">
                                <mat-label>Kommentar</mat-label>
                                <input
                                    matInput
                                    type="text"
                                    [formControl]="positionKommentarCtrl[w.warenkorb_id]"
                                /> </mat-form-field
                            ><br />
                            <span>zuletzt editiert: </span
                            ><span style="font-weight: bold; color: #555">{{ w.editiert | date: "medium" }}</span
                            ><span> von </span
                            ><span style="font-weight: bold; color: #555">{{ w.vorname }} {{ w.nachname }}</span
                            ><br />
                            <button mat-button (click)="removeWarenkorbPosition(w)" color="primary"
                                >Position entfernen</button
                            >
                        </div>
                    </div>
                    <div style="width: 100px">
                        <mat-form-field style="width: 110px">
                            <input
                                matInput
                                type="number"
                                [placeholder]="laborartikelOnly ? packNamePosition(w) : 'Menge'"
                                [formControl]="formCtrl[w.warenkorb_id]"
                            />
                            <span style="color: #aaa" matSuffix>{{ laborartikelOnly ? packNamePosition(w) : 'x' }}</span>
                            <mat-hint *ngIf="laborartikelOnly && inhaltHinweis(w)">à {{ inhaltHinweis(w) }}</mat-hint>
                        </mat-form-field>
                        <button
                            *ngIf="!inputDirtyArray[w.warenkorb_id]"
                            disabled="true"
                            mat-button
                            style="width: 100%; height: 36px"
                        ></button>
                        <button
                            *ngIf="inputDirtyArray[w.warenkorb_id]"
                            mat-raised-button
                            color="primary"
                            (click)="updateWarenkorbPosition(w)"
                            >aktualisieren</button
                        >
                    </div>
                </div>
            </mat-card>
            </ng-container>

            <button
                *ngIf="laborartikelOnly && warenkorbPositions.length > 0"
                mat-stroked-button
                type="button"
                class="vorschau-button"
                (click)="openBestellvorschauWarenkorb()"
            >
                <mat-icon>picture_as_pdf</mat-icon>
                Bestellvorschau
            </button>
            <button
                *ngIf="warenkorbPositions.length > 0"
                mat-raised-button
                color="primary"
                (click)="openReleaseWarenkorbConfirmDialog()"
                >Zur Bestellung freigeben</button
            >
        </div>
    </div>
</div>
